import { createContext } from 'react';

export const MusicContext = createContext('MusicContext 기본값');
